import { getData } from '../../_helpers/getData';
import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { throttle } from "lodash";
import { Link, useHistory } from "react-router-dom";
import CustomModal from "../ReactModal";
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import TopBar from "../topbar";
import { userTrackService } from "../../_services";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Footer from "../../layout/footer";
import constant from "../../_config/constant";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import Tippy from "@tippy.js/react";
import { AiOutlinePlus } from "react-icons/ai";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";

export default function UserTrackDataList(props) {
  const history = useHistory();
  const [modalIsOpenDetails, setModalIsOpenDetails] = React.useState(false);
  const [requesting, setRequesting] = useState(true);
  const [filters, setFilters] = useState({});
  const [list, setList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedUserData, setSelectedUserData] = useState(null);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "800px",
      maxHeight: "80vh",
      overflow: "auto",
    },
  };
  
  var limit = 10;

  const decoded = getData();

  function afterOpenModalDetails() {}

  function closeModalDetails() {
    setModalIsOpenDetails(false);
    setSelectedUserData(null);
  }

  const handleSearch = () => {
    setRefreshKey((oldKey) => oldKey + 1);
  };

  const throtteledSearch = useCallback(throttle(handleSearch, 900), []);

  const handleViewDetails = (userData) => {
    setSelectedUserData(userData);
    setModalIsOpenDetails(true);
  };

  const renderUserType = (userData) => {
    const types = [];
    if (userData.guest && Object.keys(userData.guest).length > 0) {
      types.push("Guest");
    }
    if (userData.host && Object.keys(userData.host).length > 0) {
      types.push("Host");
    }
    return types.join(", ") || "Unknown";
  };

  const renderGuestStats = (guestData) => {
    if (!guestData || !guestData.bookings) return "--";
    const { bookings } = guestData;

    let res = ""
    res += `Pending: ${bookings.pending || 0}` + "\n"
    res += `Accepted: ${bookings.accepted || 0}` + "\n"
    res += `Rejected: ${bookings.rejected || 0}` + "\n"
    res += `Cancelled: ${bookings.cancelled || 0}` + "\n"
    res += `Expired: ${bookings.expired || 0}` + "\n"
    res += `Completed: ${bookings.completed || 0}` + "\n"
    res += `Total: ${bookings.total || 0}` + "\n"

    return res;
  };

  const renderHostStats = (hostData) => {
    if (!hostData || !hostData.bookings) return "--";
    const { bookings } = hostData;
    let res = ""
    res += `Pending: ${bookings.pending || 0}` + "\n"
    res += `Accepted: ${bookings.accepted || 0}` + "\n"
    res += `Rejected: ${bookings.rejected || 0}` + "\n"
    res += `Cancelled: ${bookings.cancelled || 0}` + "\n"
    res += `Expired: ${bookings.expired || 0}` + "\n"
    res += `Completed: ${bookings.completed || 0}` + "\n"
    res += `Total: ${bookings.total || 0}` + "\n"

    return res;
  };

  const renderAirportInfo = (userData) => {
    const guestAirport =(userData.guest && userData.guest.airport) ? (userData.guest.airport.primaryListingAirportCode || 
                        userData.guest.airport.lastBookedAirportCode) : undefined
    const hostAirport =  (userData.host && userData.host.airport) ? userData.host.airport.primaryListingAirportCode : undefined;
    
    return guestAirport || hostAirport || "--";
  };

  const pageChange = (page) => {
    setPage(page);
    setRefreshKey((oldKey) => oldKey + 1);
  };

  const handleFilters = (key, value) => {
    if (value) {
      setFilters((e) => {
        const newFilter = { ...e, [key]: value };
        return newFilter;
      });
    } else {
      setFilters((e) => {
        const newFilter = { ...e };
        delete newFilter[key];
        return newFilter;
      });
    }
  };

  function handleFilterReset() {
    history.go(0);
  }

  useEffect(() => {
    setRequesting(true);
    userTrackService.trackdatalist({ page, limit: 10, ...filters, search }).then(
      (objS) => {
        setList(objS.data.docs);
        setTotal(objS.data.total);
        setRequesting(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      (error) => {
        console.log(error);
        setRequesting(false);
        toast.error("Failed to load user track data");
      }
    );
  }, [refreshKey, filters]);

  const renderDetailsModal = () => {
    if (!selectedUserData) return null;

    const { guest, host } = selectedUserData;

    return (
      <Modal
        isOpen={modalIsOpenDetails}
        onAfterOpen={afterOpenModalDetails}
        onRequestClose={closeModalDetails}
        style={customStyles}
        contentLabel="User Track Data Details"
        ariaHideApp={false}
      >
        <div>
          <div className="modal-header tw-flex tw-justify-between tw-items-center tw-mb-4">
            <h5 className="modal-title tw-text-lg tw-font-semibold">
              User Track Data Details {selectedUserData.user.name ? "- "+ selectedUserData.user.name : ""} - {selectedUserData.userId}
            </h5>
            <button
              type="button"
              className="btn-close tw-text-gray-500 hover:tw-text-gray-700"
              aria-label="Close"
              onClick={closeModalDetails}
            />
          </div>
         
          <div className="modal-body tw-space-y-6">
            <div>
                Email: {selectedUserData.user.personalEmail || "--"}
            </div>
            <div>
                Phone: {selectedUserData.user.phone || "--"}
            </div>
          
            {/* Guest Data */}
            {guest && (
              <div className="tw-border tw-rounded-lg tw-p-4">
                <h6 className="tw-font-semibold tw-text-md tw-mb-3 tw-text-blue-600">Guest Data</h6>

                {guest.lastVisitedBookingPreviewPageDate && (
                  <div className="fs-16">
                    Last Visited Booking Preview Page Date:
                    <Moment format="MMMM Do, YYYY, hh:mm">
                      {guest.lastVisitedBookingPreviewPageDate}
                    </Moment>
                </div>
                )}
                 {guest.lastCompletedCheckoutDate && (
                  <div className="fs-16">
                    Last Completed Checkout Date:
                    <Moment format="MMMM Do, YYYY, hh:mm">
                      {guest.lastCompletedCheckoutDate}
                    </Moment>
                </div>
                )}
                
                <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-text-sm">
                  <div>
                    <strong>Favorite Listings:</strong> {guest.favoriteListingCount || 0}
                  </div>
                  <div>
                    <strong>Avg Booking Value:</strong> ${(guest.averageRequestedBookingValue || 0).toFixed(2)}
                  </div>
                </div>

                {guest.bookings && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Booking Counts:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-text-xs">
                      <div>Total: {guest.bookings.total}</div>
                      <div>Pending: {guest.bookings.pending}</div>
                      <div>Accepted: {guest.bookings.accepted}</div>
                      <div>Rejected: {guest.bookings.rejected}</div>
                      <div>Completed: {guest.bookings.completed}</div>
                      <div>Cancelled: {guest.bookings.cancelled}</div>
                    </div>
                  </div>
                )}

                {guest.airport && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Airport Data:</strong>
                    <div className="tw-text-xs tw-space-y-1">
                      <div>Most Frequent: {guest.airport.mostFrequentBookingAirportCode || "--"}</div>
                      <div>Last Booked: {guest.airport.lastBookedAirportCode || "--"}</div>
                      <div>Unique Airports: {guest.airport.uniqueAirportsBookedCount || 0}</div>
                    </div>
                  </div>
                )}

                {guest.requested && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Requested Types:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-text-xs">
                      {guest.requested.coldBed && <div className="tw-px-2 tw-rounded">Cold Bed</div>}
                      {guest.requested.hotBed && <div className=" tw-px-2 tw-rounded">Hot Bed</div>}
                      {guest.requested.crashpad && <div className=" tw-px-2 tw-rounded">Crashpad</div>}
                      {guest.requested.entirePlace && <div className="tw-px-2 tw-rounded">Entire Place</div>}

                      {guest.requested.privateRoom && <div className="tw-px-2 tw-rounded">Private Room</div>}
                      {guest.requested.sharedRoom && <div className=" tw-px-2 tw-rounded">Shared Room</div>}
                      {guest.requested.maleRoom && <div className=" tw-px-2 tw-rounded">Male Room</div>}
                      {guest.requested.femaleRoom && <div className="tw-px-2 tw-rounded">Female Room</div>}
                      {guest.requested.coedRoom && <div className="tw-px-2 tw-rounded">Coed Room</div>}

                      {guest.requested.pilotOnlyRoom && <div className=" tw-px-2 tw-rounded">Pilot Only Room</div>}
                      {guest.requested.flightAttendantOnlyRoom && <div className=" tw-px-2 tw-rounded">Flight Attendant Only Room</div>}
                      {guest.requested.flightAttendantAndPilotOnlyRoom && <div className="tw-px-2 tw-rounded">Flight Attendant And Pilot Only Room</div>}
                      {guest.requested.allAirlineProfessionalsRoom && <div className="tw-px-2 tw-rounded">All Airline Professionals Room</div>}

                      {guest.requested.house && <div className=" tw-px-2 tw-rounded">House</div>}
                      {guest.requested.apartment && <div className="tw-px-2 tw-rounded">Apartment</div>}
                      {guest.requested.hotel && <div className="tw-px-2 tw-rounded">Hotel</div>}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Host Data */}
            {host && (
              <div className="tw-border tw-rounded-lg tw-p-4">
                <h6 className="tw-font-semibold tw-text-md tw-mb-3 tw-text-green-600">Host Data</h6>
                
                <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-text-sm">
                  <div>
                    <strong>Avg Booking Value:</strong> ${(host.averageRequestedBookingValue || 0).toFixed(2)}
                  </div>
                  <div>
                    <strong>Payout Status:</strong> {host.payoutVerificationStatus || "--"}
                  </div>
                </div>

                {host.listings && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Listing Counts:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-text-xs">
                      <div>Total: {host.listings.total}</div>
                      <div>Listed: {host.listings.listed}</div>
                      <div>Draft: {host.listings.draft}</div>
                      <div>Pending: {host.listings.pending}</div>
                      <div>Rejected: {host.listings.rejected}</div>
                    </div>
                  </div>
                )}

                {host.listedTypes && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Listed Types Counts:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-text-xs">
                      {host.listedTypes.coldBed != undefined && <div className="tw-px-2 tw-rounded">Cold Bed: {host.listedTypes.coldBed}</div>}
                      {host.listedTypes.hotBed != undefined && <div className=" tw-px-2 tw-rounded">Hot Bed: {host.listedTypes.hotBed}</div>}
                      {host.listedTypes.flexible != undefined && <div className=" tw-px-2 tw-rounded">Flexible: {host.listedTypes.flexible}</div>}
                      {host.listedTypes.crashpad != undefined && <div className=" tw-px-2 tw-rounded">Crashpad: {host.listedTypes.crashpad}</div>}
                      {host.listedTypes.entirePlace != undefined && <div className="tw-px-2 tw-rounded">Entire Place: {host.listedTypes.entirePlace}</div>}

                      {host.listedTypes.privateRoom != undefined && <div className="tw-px-2 tw-rounded">Private Room: {host.listedTypes.privateRoom}</div>}
                      {host.listedTypes.sharedRoom != undefined && <div className=" tw-px-2 tw-rounded">Shared Room: {host.listedTypes.sharedRoom}</div>}
                      {host.listedTypes.maleRoom != undefined && <div className=" tw-px-2 tw-rounded">Male Room: {host.listedTypes.maleRoom}</div>}
                      {host.listedTypes.femaleRoom != undefined && <div className="tw-px-2 tw-rounded">Female Room: {host.listedTypes.femaleRoom}</div>}
                      {host.listedTypes.coedRoom != undefined && <div className="tw-px-2 tw-rounded">Coed Room: {host.listedTypes.coedRoom}</div>}

                      {host.listedTypes.pilotOnlyRoom != undefined && <div className=" tw-px-2 tw-rounded">Pilot Only Room: {host.listedTypes.pilotOnlyRoom}</div>}
                      {host.listedTypes.flightAttendantOnlyRoom != undefined && <div className=" tw-px-2 tw-rounded">Flight Attendant Only Room: {host.listedTypes.flightAttendantOnlyRoom}</div>}
                      {host.listedTypes.flightAttendantAndPilotOnlyRoom != undefined && <div className="tw-px-2 tw-rounded">Flight Attendant And Pilot Only Room: {host.listedTypes.flightAttendantAndPilotOnlyRoom}</div>}
                      {host.listedTypes.allAirlineProfessionalsRoom != undefined && <div className="tw-px-2 tw-rounded">All Airline Professionals Room: {host.listedTypes.allAirlineProfessionalsRoom}</div>}

                      {host.listedTypes.house != undefined && <div className=" tw-px-2 tw-rounded">House: {host.listedTypes.house}</div>}
                      {host.listedTypes.apartment != undefined && <div className="tw-px-2 tw-rounded">Apartment: {host.listedTypes.apartment}</div>}
                      {host.listedTypes.hotel != undefined && <div className="tw-px-2 tw-rounded">Hotel: {host.listedTypes.hotel}</div>}
                    </div>
                  </div>
                )}

                {host.anyTypes && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Any Types Counts:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-text-xs">
                      {host.anyTypes.coldBed != undefined && <div className="tw-px-2 tw-rounded">Cold Bed: {host.anyTypes.coldBed}</div>}
                      {host.anyTypes.hotBed != undefined && <div className=" tw-px-2 tw-rounded">Hot Bed: {host.anyTypes.hotBed}</div>}
                      {host.anyTypes.flexible != undefined && <div className=" tw-px-2 tw-rounded">Flexible: {host.anyTypes.flexible}</div>}
                      {host.anyTypes.crashpad != undefined && <div className=" tw-px-2 tw-rounded">Crashpad: {host.anyTypes.crashpad}</div>}
                      {host.anyTypes.entirePlace != undefined && <div className="tw-px-2 tw-rounded">Entire Place: {host.anyTypes.entirePlace}</div>}

                      {host.anyTypes.privateRoom != undefined && <div className="tw-px-2 tw-rounded">Private Room: {host.anyTypes.privateRoom}</div>}
                      {host.anyTypes.sharedRoom != undefined && <div className=" tw-px-2 tw-rounded">Shared Room: {host.anyTypes.sharedRoom}</div>}
                      {host.anyTypes.maleRoom != undefined && <div className=" tw-px-2 tw-rounded">Male Room: {host.anyTypes.maleRoom}</div>}
                      {host.anyTypes.femaleRoom != undefined && <div className="tw-px-2 tw-rounded">Female Room: {host.anyTypes.femaleRoom}</div>}
                      {host.anyTypes.coedRoom != undefined && <div className="tw-px-2 tw-rounded">Coed Room: {host.anyTypes.coedRoom}</div>}

                      {host.anyTypes.pilotOnlyRoom != undefined && <div className=" tw-px-2 tw-rounded">Pilot Only Room: {host.anyTypes.pilotOnlyRoom}</div>}
                      {host.anyTypes.flightAttendantOnlyRoom != undefined && <div className=" tw-px-2 tw-rounded">Flight Attendant Only Room: {host.anyTypes.flightAttendantOnlyRoom}</div>}
                      {host.anyTypes.flightAttendantAndPilotOnlyRoom != undefined && <div className="tw-px-2 tw-rounded">Flight Attendant And Pilot Only Room: {host.anyTypes.flightAttendantAndPilotOnlyRoom}</div>}
                      {host.anyTypes.allAirlineProfessionalsRoom != undefined && <div className="tw-px-2 tw-rounded">All Airline Professionals Room: {host.anyTypes.allAirlineProfessionalsRoom}</div>}

                      {host.anyTypes.house != undefined && <div className=" tw-px-2 tw-rounded">House: {host.anyTypes.house}</div>}
                      {host.anyTypes.apartment != undefined && <div className="tw-px-2 tw-rounded">Apartment: {host.anyTypes.apartment}</div>}
                      {host.anyTypes.hotel != undefined && <div className="tw-px-2 tw-rounded">Hotel: {host.anyTypes.hotel}</div>}
                    </div>
                  </div>
                )}

                {host.bookings && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Booking Counts:</strong>
                    <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-text-xs">
                      <div>Total: {host.bookings.total}</div>
                      <div>Pending: {host.bookings.pending}</div>
                      <div>Accepted: {host.bookings.accepted}</div>
                      <div>Rejected: {host.bookings.rejected}</div>
                      <div>Completed: {host.bookings.completed}</div>
                      <div>Cancelled: {host.bookings.cancelled}</div>
                    </div>
                  </div>
                )}

                {host.response && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Response Rates:</strong>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-text-xs">
                      <div>Accept Rate: {((host.response.acceptButtonClickRate || 0) * 100).toFixed(1)}%</div>
                      <div>Reject Rate: {((host.response.rejectRate || 0) * 100).toFixed(1)}%</div>
                      <div>Response Rate: {((host.response.responseRate || 0) * 100).toFixed(1)}%</div>
                      <div>Cancel Rate: {((host.response.cancellationRate || 0) * 100).toFixed(1)}%</div>
                      <div>Expired Rate: {((host.response.expiredRate || 0) * 100).toFixed(1)}%</div>
                    </div>
                  </div>
                )}

                {host.airport && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Airport Data:</strong>
                    <div className="tw-text-xs tw-space-y-1">
                      <div>Primary Airport: {host.airport.primaryListingAirportCode || "--"}</div>
                      <div>Primary City: {host.airport.primaryListingCity || "--"}</div>
                      <div>Unique Airports: {host.airport.uniqueAirportsCount || 0}</div>
                    </div>
                  </div>
                )}

                {host.messages && (
                  <div className="tw-mt-3">
                    <strong className="tw-block tw-mb-2">Messages Data:</strong>
                    <div className="tw-text-xs tw-space-y-1">
                      <div>Total Received: {host.messages.received || "--"}</div>
                      <div>Total Responded: {host.messages.responded || "--"}</div>
                      <div>Response Rate: {((host.messages.responseRate || 0) * 100).toFixed(1)} %</div>
                      <div>Avarage Response Time (m): {host.messages.averageResponseTime ? host.messages.averageResponseTime.toFixed(1) : "--"}</div>
                    </div>
                  </div>
                )}
                {host.subscription && (
                   <div className="tw-mt-3">
                   <strong className="tw-block tw-mb-2">Subscription:</strong>
                   <div className="tw-text-xs tw-space-y-1">
                     <div>Has Active Subscription: {host.subscription.hasActiveSubscription ? "Yes" : "No"}</div>
                     <div>Active Subscription Plan: {host.subscription.activePlan || "--"}</div>
                     <div>Last Subscription Plan: {host.subscription.lastPlan || "--"}</div>
                     <div>Status: {host.subscription.status || "--"}</div>
                     <div>Renewal Date: {host.subscription.renewDate || "--"}</div>
                     <div>Last Subscription Payment Date: {host.subscription.lastSubscriptionPaymentDate || "--"}</div>
                     <div>Has Overdue Subscription Payment: {host.subscription.hasOverdueSubscriptionPayment ? "Yes" : "No"}</div>
                     <div>Payment Grace End Date: {host.subscription.paymentGraceEndDate || "--"}</div>
                     <div>Is In Grace Period: {host.subscription.isInGracePeriod  ? "Yes" : "No"}</div>
                     <div>Failed Subscription Payment Reason: {host.subscription.failedSubscriptionPaymentReason || "--"}</div>
                     <div>Failed Subscription Payment Count: {host.subscription.failedSubscriptionPaymentCount || "--"}</div>
                     <div>Failed Payment Retry Count: {host.subscription.failedPaymentRetryCount || "--"}</div>
                     <div>Last Subscription Failed Payment Date: {host.subscription.lastSubscriptionFailedPaymentDate || "--"}</div>
                     <div>Has Been Unlisted For Payment: {host.subscription.hasBeenUnlistedForPayment ? "Yes" : "No"}</div>
                     <div>Unlisted Date For Payment: {host.subscription.hostUnlistedDate || "--"}</div>
                     <div>Reactivation Date: {host.subscription.reactivationDate || "--"}</div>
                     <div>First Activation Date: {host.subscription.firstActivationDate || "--"}</div>
                    </div>
                 </div>
                )}
              </div>
            )}
          </div>
          
          <div className="tw-flex tw-justify-end tw-mt-6">
            <button 
              onClick={closeModalDetails}
              className="tw-px-4 tw-py-2 tw-bg-gray-500 tw-text-white tw-rounded hover:tw-bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div id="main-wrapper">
      {renderDetailsModal()}
      <ToastContainer />
      <TopBar
        user={decoded}
        showSearch={true}
        handleSearch={(e) => {
          setSearch(e.target.value);
          throtteledSearch(e.target.value);
        }}
        search={search}
        title="User Track Data List"
      />

      <div className="deznav">
        <div className="deznav-scroll">
          <Navbar />
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <h4 className="tw-text-xl tw-font-medium">Filter</h4>
              <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-5 tw-gap-2 tw-mb-4">
                <div>
                  <label className="text-label form-label">User Type</label>
                  <select
                    onChange={(e) => handleFilters("type", e.target.value)}
                    className="form-control form-control-sm wide"
                    name="userType"
                  >
                    <option value="">All</option>
                    <option value="guest">Guest or Both</option>
                    <option value="guestonly">Guest Only</option>
                    <option value="host">Host or Both</option>
                    <option value="hostonly">Host Only</option>
                    <option value="both">Both only</option>
                  </select>
                </div>
                
                <div>
                  <label className="text-label form-label">Payout Status</label>
                  <select
                    onChange={(e) => handleFilters("payoutStatus", e.target.value)}
                    className="form-control form-control-sm wide"
                    name="payoutStatus"
                  >
                    <option value="">Select</option>
                    <option value="Verified">Verified</option>
                    <option value="Unverified">Unverified</option>
                    <option value="In Review">In Review</option>
                  </select>
                </div>

                <div>
                  <label className="text-label form-label">Has Listings</label>
                  <select
                    onChange={(e) => handleFilters("hasListings", e.target.value)}
                    className="form-control form-control-sm wide"
                    name="hasListings"
                  >
                    <option value="">All</option>
                    <option value="true">Has Listings</option>
                    <option value="false">No Listings</option>
                  </select>
                </div>

                <div>
                  <label className="text-label form-label">Airport Code</label>
                  <input
                    onChange={(e) => handleFilters("airport", e.target.value)}
                    type="text"
                    name="airport"
                    className="form-control form-control-sm"
                    placeholder="e.g., LAX, JFK"
                  />
                </div>

                <div>
                  <label className="text-label form-label">Reset Filter</label>
                  <button
                    onClick={handleFilterReset}
                    className="btn-sm btn btn-primary form-control form-control-sm"
                  >
                    Reset
                  </button>
                </div>
              </div>

              {requesting && (
                <div className="tw-my-10 tw-flex tw-items-center tw-justify-center">
                  <div className="bg-white tw-w-max rounded shadow-md p-4">
                    <div className="loader"></div>
                  </div>
                </div>
              )}

              <div className="tab-content">
                <div className="tab-pane active show" id="All">
                  <div className="table-responsive">
                    <table
                      className="table card-table display mb-4 dataTablesCard table-responsive-lg"
                      id="userTrackTable"
                    >
                      <thead>
                        <tr>
                          <th>Actions</th>
                          <th>User ID</th>
                          <th>Type</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Guest Stats</th>
                          <th>Host Stats</th>
                          <th>Primary Airport</th>
                          <th>Payout Status</th>
                          <th>Last Updated</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((userData) => (
                          <tr key={userData._id}>
                            <td>
                              <button
                                onClick={() => handleViewDetails(userData)}
                                className="tw-p-2 tw-px-4 tw-text-xs tw-bg-primary tw-text-white tw-rounded tw-mr-2"
                              >
                                View Details
                              </button>
                            </td>
                            <td>
                              <span className="fs-16">{userData.userId}</span>
                            </td>
                            <td>
                              <span className="fs-16">{renderUserType(userData)}</span>
                            </td>
                            <td>
                              <span className="fs-16">{userData.user.name || "--"}</span>
                            </td>
                            <td>
                              <span className="fs-16">{userData.user.phone || "--"}</span>
                            </td>
                            <td>
                              <span className="fs-16">{userData.user.personalEmail || "--"}</span>
                            </td>
                            <td>
                              <span className="fs-16">{renderGuestStats(userData.guest)}</span>
                            </td>
                            <td>
                              <span className="fs-16">{renderHostStats(userData.host)}</span>
                            </td>
                            <td>
                              <span className="fs-16">{renderAirportInfo(userData)}</span>
                            </td>
                            <td>
                              <span className="fs-16">
                                {(userData.host && userData.host.payoutVerificationStatus) ? userData.host.payoutVerificationStatus || "--" : "--"}
                              </span>
                            </td>
                            <td>
                              <span className="fs-16">
                                <Moment format="MMMM Do, YYYY">
                                  {userData.updatedAt}
                                </Moment>
                              </span>
                            </td>
                            <td>
                              <span className="fs-16">
                                <Moment format="MMMM Do, YYYY">
                                  {userData.createdAt}
                                </Moment>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            activePage={page}
            itemsCountPerPage={limit}
            totalItemsCount={total}
            pageRangeDisplayed={10}
            onChange={pageChange}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}